import { datadogLogs, LogsEvent } from '@datadog/browser-logs';
import { ConfigDataDog } from '@dh-io-emh/config-types';

export const initDataDog = (
  prefix = '',
  { clientToken, site, service, env, enabled, tenantId, proxyUrl }: ConfigDataDog,
  shopCountry: string,
  locale: string,
) => {
  const formatMessage = (message) => {
    if (message.includes('fcis')) {
      const match = message.match(/"code": "?(.*)"?,?/);

      return `[FCIS]: ${(match && match[1]) ?? 'UNKNOWN ERROR'}`;
    }

    const hasPrefix = message.includes(prefix);

    // this is to remove all css related from the message
    message = message.split(';');

    return hasPrefix ? `[${prefix?.toUpperCase()}]:${message[message.length - 1]}` : message[message.length - 1];
  };

  const isWbSliderError = (log: LogsEvent) => log.error?.stack?.includes('SliderComponent.updateScrollSpacing');

  if (enabled) {
    datadogLogs.init({
      clientToken,
      env,
      site,
      service,
      version: process.env.VUE_APP_VERSION,
      forwardErrorsToLogs: true,
      sampleRate: 100,
      beforeSend: (log) => {
        // EMHHB-1691: wb-slider is throwing a lot of unhandled errors that heavily spam datadog
        // For now we prevent logging these errors until WB fixes the underlying root cause (https://git.i.mercedes-benz.com/dh-io-workbench/core/issues/3239)
        if (isWbSliderError(log)) {
          return false;
        }

        if (log.message) {
          log.message = formatMessage(log.message);
        }

        if (log.error?.message) {
          log.error.message = formatMessage(log.error.message);
        }
      },
      proxyUrl,
    });
    datadogLogs.addLoggerGlobalContext('tenant', tenantId);
    datadogLogs.addLoggerGlobalContext('country', shopCountry);
    datadogLogs.addLoggerGlobalContext('locale', locale);
  }

  return datadogLogs;
};
